import React from 'react';
import cugate from '../images/cugate.png'


function LandingFooter() {

    const year = new Date().getFullYear();

    return (
        <section id="footerSection">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="d-flex flex-column justify-content-center align-items-center mt-2 mb-4">
                            <img src={cugate} id="cugateLogoFooter" alt = '' className="my-4" />
                            <div id="footerText" className="text-white">© {new Date().getFullYear()} CuGate AG. All rights reserved.</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default LandingFooter;